import { ONE_MIN_IN_MS } from 'shared/globalConsts';
import { ListsType } from 'shared/store/distributionListStore/types';
import { ProductsListsType } from 'shared/store/productionListStore/types';

export const checkMustLoad = (lists: ListsType | ProductsListsType, date: string) =>
  Boolean(Number(lists[date]?.lastUpdated || 0) + 15 * ONE_MIN_IN_MS < new Date().getTime());
